%div-draggable-class {
  background-color: var(--daybreak-blue-3-color);
  cursor: col-resize;

  &::before {
    background-color: var(--daybreak-blue-2-color);
  }
}

.div-draggable:is(div) {
  @extend %div-draggable-class;

  background-color: var(--daybreak-blue-6-color) !important;
}

.container {
  --z-index-cell-resizable-table: var(
    --z-index-cell-resizable-table-tab-template-component,
    7
  );
  --next-offset: 32px;
  --padding-left-selection-column-default: 20px;
  --offset-left-selection: calc(
    var(--next-offset) - var(--padding-left-selection-column-default)
  );

  table {
    --height-resizable-table: 100%;

    min-width: 100%;
  }

  th {
    --z-index-th: 2;

    z-index: var(--z-index-th) !important;

    &:hover {
      overflow: visible !important;
      z-index: calc(var(--z-index-th) + 1) !important;
    }
  }

  td:first-child,
  th:first-child {
    position: sticky !important;
    left: var(--padding-left-right-page-with-tabs-template) !important;
  }

  th:global(.ant-table-selection-column),
  td:global(.ant-table-selection-column) {
    position: sticky !important;
    left: calc(
      var(--padding-left-right-page-with-tabs-template) +
        var(
          --padding-left-selection-column,
          var(--padding-left-selection-column-default)
        )
    ) !important;
  }

  th:global(.ant-table-selection-column) + th,
  td:global(.ant-table-selection-column) + td {
    position: sticky !important;
    left: calc(
      var(--padding-left-right-page-with-tabs-template) +
        var(
          --padding-left-selection-column,
          var(--padding-left-selection-column-default)
        ) +
        var(--next-offset)
    ) !important;
  }

  td:global(.ant-table-selection-column) {
    z-index: 1 !important;
    background-color: var(--neutral-1-color);
  }

  td:global(.ant-table-selection-column) + td {
    z-index: 1 !important;
    background-color: var(--neutral-1-color);
  }

  th:first-child,
  th:global(.ant-table-selection-column),
  th:global(.ant-table-selection-column) + th {
    z-index: var(--z-index-cell-resizable-table) !important;

    &:hover {
      z-index: var(--z-index-cell-resizable-table) !important;
    }
  }

  tr:not(:global(.ant-table-row-selected))
    > td:first-child:global(.ant-table-cell-row-hover),
  th:global(.ant-table-selection-column),
  th:global(.ant-table-selection-column) + th {
    background-color: var(--neutral-2-color) !important;
  }

  tr:not([data-opened-in-drawer="true"]) {
    td:first-child {
      z-index: 1;
    }
  }

  tr:not([data-opened-in-drawer="true"], :global(.ant-table-row-selected)) {
    > td:not(:global(.ant-table-cell-row-hover)):first-child {
      background-color: var(
        --color-bg-ant-table-row-expand-icon-cell,
        var(--neutral-1-color)
      ) !important;
    }
  }
}

.resizer-th:is(div) {
  position: absolute;
  height: var(--height-resizable-table);
  right: 0;
  top: 0;
  width: 1px;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -3px;
    width: 7px;
    height: 38px;
    opacity: 0.4;
  }

  &:hover {
    @extend %div-draggable-class;
  }
}

.cover {
  position: fixed;
  height: calc(100vh - 108px - 56px);
  width: var(--padding-left-right-page-with-tabs-template);
  background-color: var(--neutral-1-color);
  z-index: 10;
  transform: translate(
    calc(var(--padding-left-right-page-with-tabs-template) * -1),
    var(--y-cover-translation-resizable-table, -60px)
  );
}
